import { getStorage, setStorage } from "./storedData/useStorage";

const STORAGE_PREFIX = "gympin-favorites-v1";

function storageKey(userId) {
    return `${STORAGE_PREFIX}-${userId}`;
}

export function toFavoriteSnapshot(place) {
    if (!place?.Id) return null;
    return {
        Id: place.Id,
        Name: place.Name || "",
        Multimedias: place.Multimedias || [],
        MinPrice: place.MinPrice ?? null,
        MinPriceBeforeDiscount: place.MinPriceBeforeDiscount ?? null,
        Location: place.Location
            ? {
                Name: place.Location.Name,
                parentName: place.Location.parentName
            }
            : null,
        Genders: place.Genders || [],
        Sports: place.Sports || [],
        ActiveTimes: place.ActiveTimes || null,
        AddedAt: Date.now()
    };
}

export function getFavorites(userId) {
    if (!userId) return [];
    try {
        const raw = getStorage(storageKey(userId));
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

function persistFavorites(userId, list) {
    if (!userId) return false;
    return setStorage(storageKey(userId), JSON.stringify(list));
}

export function isFavorite(userId, placeId) {
    if (!userId || placeId == null) return false;
    return getFavorites(userId).some((item) => item.Id === placeId);
}

/**
 * @returns {{ list: Array, added: boolean } | null}
 * null when place is invalid; added=true when newly favorited
 */
export function toggleFavorite(userId, place) {
    if (!userId || !place?.Id) return null;

    const list = getFavorites(userId);
    const index = list.findIndex((item) => item.Id === place.Id);

    if (index >= 0) {
        const next = [...list.slice(0, index), ...list.slice(index + 1)];
        persistFavorites(userId, next);
        return { list: next, added: false };
    }

    const snapshot = toFavoriteSnapshot(place);
    if (!snapshot) return null;
    const next = [snapshot, ...list];
    persistFavorites(userId, next);
    return { list: next, added: true };
}

export function removeFavorite(userId, placeId) {
    if (!userId || placeId == null) return getFavorites(userId);
    const next = getFavorites(userId).filter((item) => item.Id !== placeId);
    persistFavorites(userId, next);
    return next;
}
